export const paywallConfig = {
    "locks": {
        "0xF19F3Eef84CfB45C8a1eD8d3dBBa9842e1407da0": {
            'network': 56,
            'name': "My Membership"
        }
    },
    'icon': "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%3Fid%3DOIP.10UUFNA8oLdFdDpzt-Em_QHaHa%26pid%3DApi&f=1",
    'title':"unlock Testing",
    'skipRecipient': true,
    
}

export const goerliAddress = "0x9ADe6Ed97678fe17D9f0277A7351D7aE698109d0";
export const binanceAddress = "0xF19F3Eef84CfB45C8a1eD8d3dBBa9842e1407da0"
export const binanceAddressmine = "0xb8319cD99f2f9E406668f6e0973A933Fdc908FB4"
export const aprilAddress = "0xbfeA674ce7d16E26E39e3c088810367a708eF94C"
export const goerli24 = "0x57Bc254cC27cf3427b62Ce3B185A8430622f1425"
export const binance24address = "0x64221c6509c48595b2e04c9606fdc389f7c09a31"